import { Button, Stack, Icon } from '@chakra-ui/react'

import { ResponsiveLogo, FullPageLayout, DrawerMenu } from '..'

import { FaCircle } from 'react-icons/fa'

export const Navbar = () => {

	const NavButtons = () => {
		const isAuthenticated = false

		const onClick = () => {
			alert('Esta funcionalidade está em desenvolvimento!')
		}

		if (!isAuthenticated) {
			return (
				<Stack direction={{ base: 'column', md: 'row'}} align="center">
					<Button onClick={onClick} variant="default">Monitoramento</Button>
					<Button 
						onClick={onClick} 
						variant="default" 
						color="gray.900"
						fontWeight="bold"
						py={6}
						px={2.5}
						pr={8}
						leftIcon={<Icon as={FaCircle} color="#D9D9D9" boxSize={8} />}
					>Login</Button>
				</Stack>
			)
		}
		
		return (
			<DrawerMenu placement='top'>
				<Stack direction={{ base: 'column', md: 'column', lg: 'row' }}>
					<Button variant="nav" bg="esmeralda.100">Cadastro de informações</Button>
					<Button variant="nav" bg="esmeralda.80">Dashboard</Button>
					<Button variant="nav" bg="esmeralda.80">Monitoramento</Button>
					<Button variant="nav" bg="esmeralda.80">Avaliação</Button>
					<Button variant="nav" bg="esmeralda.60">Login</Button>
				</Stack>
			</DrawerMenu>
		)
	}

  return (
		<FullPageLayout bg='gray.180' shadow='md'>
			<Stack
				py={6}
				spacing={6}
				direction={{ base: 'column', sm: 'row'}}
				alignItems={{ base: 'center', sm: 'end'}}
				justifyContent="space-between"
			>
				<ResponsiveLogo />

				<NavButtons />
			</Stack>
		</FullPageLayout>
  )
}